import React from "react";
import { View, StyleSheet, Text } from "react-native";

export default function Events() {
  return (
    <View style={styles.screen}>
      <Text>Events Screen</Text>
    </View>
  );
}
const styles = StyleSheet.create({
  screen: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});
